import React, { Component } from 'react';
import { Translation } from 'react-i18next';

function Ans5() {
  return (
    <Translation>
      {(t) => (
        <div className="bg">
          <ol className="ans">
            <li>
              <b className="fisrt-line">{t('ans_5.text_1')}</b>
              <p>{t('ans_5.text_2')}</p>
            </li>
          </ol>
        </div>
      )}
    </Translation>
  );
}

export default Ans5;
